var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading-page",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"loading-box"},[_c('van-loading',{attrs:{"type":"spinner","size":"46","vertical":"","color":"#fff"}},[_c('span',{staticClass:"msg-text"},[_vm._v(_vm._s(_vm.message))])])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }